import { supabase } from '../lib/supabaseClient';
import type { EstadoCopiaGarra } from '../domain/garraCopia';

/**
 * Estado de la copia nocturna de asistencia GARRA → central, con la campaña a la que llega.
 * Devuelve null si no hay configuración o si quien mira no puede leerla (las dos tablas solo las
 * leen admin y coordinador): el aviso, entonces, no se dibuja.
 */
export async function getEstadoCopiaGarra(): Promise<(EstadoCopiaGarra & { campaignId: string }) | null> {
  const [{ data: cfg, error: e1 }, { data: est, error: e2 }] = await Promise.all([
    supabase.from('garra_sync_config').select('campaign_id').maybeSingle(),
    supabase.from('garra_sync_estado').select('alerta, ultima_ok, ultimas_insertadas').maybeSingle(),
  ]);
  if (e1 || e2 || !cfg || !est) return null;
  return {
    campaignId: cfg.campaign_id as string,
    alerta: (est.alerta as string | null) ?? null,
    ultimaOk: (est.ultima_ok as string | null) ?? null,
    ultimasInsertadas: (est.ultimas_insertadas as number | null) ?? null,
  };
}
